import { render, staticRenderFns } from "./purchaseLogs.vue?vue&type=template&id=87b81e80&"
import script from "./purchaseLogs.vue?vue&type=script&lang=js&"
export * from "./purchaseLogs.vue?vue&type=script&lang=js&"
import style0 from "./purchaseLogs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports